import { render, staticRenderFns } from "./VaccinationForm.vue?vue&type=template&id=000806f1&scoped=true"
import script from "./VaccinationForm.vue?vue&type=script&lang=js"
export * from "./VaccinationForm.vue?vue&type=script&lang=js"
import style0 from "./VaccinationForm.vue?vue&type=style&index=0&id=000806f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000806f1",
  null
  
)

export default component.exports